import {
  listGoods,
  partSave,
  setStock,
  getPartsPrice,
  savePartsPrice
} from '@/api/myweb/goods/goodsManage'
import {
  getListPartsType,
  getListAllBrand,
  getListAllLabel,
  getDataFrom,
  undercarriage,
  getNewGoods,
  putAway
} from '@/api/myweb/goods/goodsManagement'
import urlObj from '@/config/env.js'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
export const dataMixin = {
  data() {
    const priceValidatePass = (rule, value, callback) => {
      console.log(this.priceForm.priceListOne)
      let priceReg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (this.priceForm.priceType == 0) {
        if (!this.priceForm.priceListZero[0].price) {
          callback(new Error('一口价价格为必填项'))
        } else {
          if (!priceReg.test(this.priceForm.priceListZero[0].price)) {
            callback(new Error('价格大于0且最多两位小数'))
          } else {
            callback()
          }
        }
      }
      if (this.priceForm.priceType == 1) {
        let priceNum = 0
        let num = 0
        let reg = /^[1-9]\d*$/

        this.priceForm.priceListOne.forEach(item => {
          // 判断有效列表数量
          if (item.orderQuantity) {
            num++
            // 判断数量是否为正整数
            if (!reg.test(item.orderQuantity)) {
              callback(new Error('数量为正整数'))
            }
            if (item.price) {
              // 判断价格是否为>0且最多两位小数
              if (!priceReg.test(item.price)) {
                callback(new Error('价格大于0且最多两位小数'))
              }
            } else {
              priceNum++
            }
          }
        })
        if (priceNum != 0) {
          callback(new Error('阶梯价格价格为必填项'))
        } else {
          if (num < 2) {
            callback(new Error('请至少设置2个阶梯'))
          } else {
            callback()
          }
        }
      }
    }
    return {
      // token: JSON.parse(window.sessionStorage.getItem('vuex')).user.token,
      tenantType: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
        .tenantType,
      token: Cookies.get(TOKEN_KEY),
      pager: {
        current: 1,
        size: 30,
        total: 0
      },
      addPager: {
        current: 1,
        size: 30,
        total: 0
      },
      tableLoading: true,
      addTableLoading: true,
      selectLoading: false,
      matchLoading: false,
      priceEdit: false,
      soldoutLoading: false,
      putawayLoading: false,
      exportLoading: false,
      stockOkLoading: false,
      priceOkLoading: false,
      priceForm: {
        partsId: '',
        priceType: '',
        priceListZero: [], // 一口价价格列表
        priceListOne: [] // 阶梯价格列表
      },
      stockEdit: false,

      // 销售表单验证规则
      priceRoules: {
        priceType: [
          {
            required: true,
            message: '请选择价格类型',
            trigger: 'change'
          }
        ],
        price: [
          { required: true, validator: priceValidatePass, trigger: 'change' }
        ]
      },
      stockForm: {
        partId: '',
        name: '',
        stock: 0
      },
      stockRoules: {
        stock: [
          {
            required: true,
            message: '库存必填 ',
            trigger: 'change'
          },
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: '库存为正整数 ',
            trigger: 'change'
          }
        ]
      },
      screenHeight: '',
      tableData: [],
      selectData: {
        keyword: '',
        partsType: '',
        carBrandId: '',
        shelfStatus: ''
      },
      selectObj: {
        keyword: '',
        partsType: '',
        carBrandId: '',
        shelfStatus: ''
      },
      partsTypeList: [],
      carBrandIdList: [],
      shelfStatusList: [],
      addPartsTypeList: [],
      sort: { priceSort: '', salesVolumeSort: '', stockSort: '' }, //排序
      // 新增商品
      addGoods: false,
      addStatus: 0,
      addSelectData: {
        keyword: '',
        partsType: '',
        carBrandId: ''
      },
      addTableData: [],
      addRules: {
        partsType: [
          {
            required: true,
            message: '配件类型不能为空',
            type: 'number',
            trigger: 'change'
          }
        ],
        carBrandId: [
          {
            required: true,
            message: '品牌不能为空',
            trigger: 'change'
          }
        ],
        keyword: [
          {
            required: true,

            message: '编码/名称不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.getListPartsType()
    this.getshelfStatusList()
  },
  methods: {
    refush(){
      this.getList()
    },
    // TODO 【第二迭代】 去商品编辑新页面
    goEditPage(row) {
      console.log(row)
      let val = {partId:row.id,jiapeiPartId:row.jiapeiPartId}
      console.log(val);
      sessionStorage.setItem('editIds',JSON.stringify(val))
      console.log(JSON.parse(sessionStorage.getItem('editIds')));
      this.$router.push({
        path: '/editGood',
        query: {
          partId: row.id,
          jiapeiPartId: row.jiapeiPartId
        }
      })
      // window.open(routeInfo.href, '_blank')
    },
    // 货架状态
    async getshelfStatusList() {
      let res = await getDataFrom(['HJZT'])
      console.log(res)

      this.shelfStatusList = res.data['HJZT']

      this.getList()
    },
    // 获取列表
    async getList() {
      this.tableLoading = true
      let data = {
        carBrandId: this.selectObj.carBrandId,
        keyword: this.selectObj.keyword,
        partsType: this.selectObj.partsType,
        shelfStatus: this.selectObj.shelfStatus,
        priceSort: this.sort.priceSort,
        salesVolumeSort: this.sort.salesVolumeSort,
        stockSort: this.sort.stockSort,
        current: this.pager.current,
        size: this.pager.size
      }
      console.log(data)
      let res = await listGoods(data)
      this.tableLoading = false
      this.selectLoading = false
      console.log(res)

      this.tableData = res.data.records
      this.pager.total = res.data.total
    },
    // 列表排序
    sortChangeEvent({ sortList }) {
      // console.log(sortList)
      this.sort = { priceSort: '', salesVolumeSort: '', stockSort: '' } //排序

      sortList.forEach(item => {
        console.log(item.property)
        if (item.property == 'sellingPrice') {
          this.sort.priceSort = item.order == 'desc' ? 2 : 1
        }
        if (item.property == 'stock') {
          this.sort.stockSort = item.order == 'desc' ? 2 : 1
        }
        if (item.property == 'salesVolume') {
          this.sort.salesVolumeSort = item.order == 'desc' ? 2 : 1
        }
      })
      this.pager = {
        current: 1,
        size: 30,
        total: 0
      }
      console.log(this.sort)
      this.getList()
    },
    // 搜索
    selectEvent() {
      this.selectLoading = true
      // 清除排序
      this.$refs.tableData.clearSort()
      this.sort = { priceSort: '', salesVolumeSort: '', stockSort: '' } //排序
      this.pager = {
        current: 1,
        size: 30,
        total: 0
      }
      this.selectObj = JSON.parse(JSON.stringify(this.selectData))
      console.log(this.selectObj)
      this.getList()
    },
    // 重置
    reset() {
      this.selectData = {
        keyword: '',
        partsType: '',
        carBrandId: '',
        shelfStatus: ''
      }
      this.carBrandIdList = []
      this.selectObj = JSON.parse(JSON.stringify(this.selectData))
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.pager.current = currentPage
      this.pager.size = pageSize
      console.log(currentPage, pageSize)
      this.getList()
    },
    // 配件类型获取
    async getListPartsType() {
      let res = await getListPartsType()
      console.log(res)

      this.partsTypeList = res.data
    },
    // 配件类型改变
    async typeChange(type) {
      console.log(type)
      if (type) {
        console.log(type.label)
        this.carBrandIdList = []
        this.selectData.carBrandId = ''
        let res
        if (type.label.search('原厂件') !== -1) {
          res = await getListAllLabel()
        } else {
          res = await getListAllBrand()
        }

        this.carBrandIdList = res.data
      }
    },
    // 上架
    async putaway() {
      let selectRecords = this.$refs.tableData.getCheckboxRecords()
      console.log(selectRecords)
      if (selectRecords.length <= 0) {
        this.$Message.destroy()
        this.$Message.error('请选择商品')
        return
      }
      let putawayArr = selectRecords.filter(item => {
        return item.auditStatus == 1
      })
      console.log(putawayArr)
      if (putawayArr.length != selectRecords.length) {
        this.$Message.destroy()
        this.$Message.error('所选择商品必须为"审核通过"状态')
        return
      }
      this.putawayLoading = true
      let arr = putawayArr.map(item => item.id)
      console.log(arr)
      let res = await putAway(arr)
      console.log(res)
      this.putawayLoading = false
      if (res.code == 0) {
        this.getList()
        this.$Message.success('更改成功')
      }
    },
    // 下架
    async soldout() {
      let selectRecords = this.$refs.tableData.getCheckboxRecords()
      console.log(selectRecords)
      if (selectRecords.length <= 0) {
        this.$Message.destroy()
        this.$Message.error('请选择商品')
        return
      }
      let putawayArr = selectRecords.filter(item => {
        return item.auditStatus == 1
      })
      console.log(putawayArr)
      if (putawayArr.length != selectRecords.length) {
        this.$Message.destroy()
        this.$Message.error('所选择商品必须为"审核通过"状态')
        return
      }
      this.soldoutLoading = true
      let arr = putawayArr.map(item => item.id)
      console.log(arr)
      let res = await undercarriage(arr)
      console.log(res)
      this.soldoutLoading = false

      if (res.code == 0) {
        this.getList()
        this.$Message.success('更改成功')
      }
    },
    // 导出
    async exportExcel() {
      this.exportLoading = true
      // 动态创建a链接
      let a = document.createElement('a')
      a.setAttribute('target', '_blank')
      a.href = `${urlObj.wss}wss-part/parts/partExport?keyword=${this.selectObj.keyword}&partsType=${this.selectObj.partsType}&carBrandId=${this.selectObj.carBrandId}&shelfStatus=${this.selectObj.shelfStatus}&access_token=${this.token}`

      document.body.appendChild(a)
      a.click() // 下载
      URL.revokeObjectURL(a.href) // 释放URL 对象
      document.body.removeChild(a) // 删除 a 标签
      setTimeout(() => {
        this.exportLoading = false
      }, 1000)
      console.log(this.exportLoading, 22)
    },
    // 新增model***************
    // 新增按钮
    addGoodsEvent() {
      this.addGoods = true
      this.$refs.addForm.resetFields()
      this.addStatus = 0
      this.addTableData = []
    },
    //新增配件类型改变
    async addTypeChange(type) {
      console.log(type)
      if (type) {
        console.log(type.label)
        this.addPartsTypeList = []
        this.addSelectData.carBrandId = ''
        let res
        if (type.label.search('原厂件') !== -1) {
          res = await getListAllLabel()
        } else {
          res = await getListAllBrand()
        }

        this.addPartsTypeList = res.data
      }
    },
    // 匹配平台库
    getMatchingData() {
      console.log('验证事件')
      this.$refs.addForm.validate(valid => {
        console.log(valid)
        if (valid) {
          this.matchLoading = true
          this.addPager = {
            current: 1,
            size: 30,
            total: 0
          }

          this.addStatus = 1
          // 请求表格数据
          this.getAddListData()
        } else {
          this.$Message.error('表单验证失败!')
        }
      })
    },
    // 新增表格数据
    async getAddListData() {
      this.addTableLoading = true
      let data = {
        brandName: this.addSelectData.carBrandId,
        // brandName: '宝马',
        qualityTypeId: this.addSelectData.partsType,
        partCode: this.addSelectData.keyword,
        current: this.addPager.current,
        size: this.addPager.size
      }
      console.log(data)
      let res = await getNewGoods(data)
      console.log(res)

      this.matchLoading = false
      this.addTableLoading = false
      this.addTableData = res.data.records
      this.addPager.total = res.data.total
      if (res.data.records.length == 0) {
        this.addStatus = 2
      }
    },
    // 新增分页
    addHandlePageChange({ currentPage, pageSize }) {
      this.addPager.current = currentPage
      this.addPager.size = pageSize
      console.log(currentPage, pageSize)
      this.getAddListData()
    },
    // 新增添加
    async addSelectEvent(row) {
      console.log(row)
      let data = JSON.parse(JSON.stringify(row))
      data.jiapeiPartId = data.id
      data.buyStatus = data.buyStatus ? data.buyStatus.value : ''
      data.dataSource = data.dataSource ? data.dataSource.value : ''
      data.qualityTypeId = data.qualityTypeId ? data.qualityTypeId.value : ''
      data.status = data.status ? data.status.value : ''

      delete data.id
      console.log(data)
      let res = await partSave(data)
      console.log(res)
      if (res.status) {
        this.$Message.success('保存成功')
        this.getList()
      }
    },

    // 价格库存model******************************
    // 价格回显
    async getPartsPrice(partsId) {
      let res = await getPartsPrice({ partsId })
      console.log(res)
      // if (res.code == 0) {

      this.priceForm.priceType = res.data.priceType ? res.data.priceType : ''
      this.priceForm.priceList = res.data.priceVOS ? res.data.priceVOS : [{}]
      if (this.priceForm.priceType == 1) {
        this.priceForm.priceListOne = res.data.priceVOS
          ? res.data.priceVOS
          : [{}] // 价格列表
        this.priceForm.priceListZero = [{ orderQuantity: 1, price: '' }]
        this.priceForm.priceListOne.push({})
      } else {
        this.priceForm.priceListZero = res.data.priceVOS
          ? res.data.priceVOS
          : [{ orderQuantity: 1, price: '' }] // 价格列表
        this.priceForm.priceListOne = [{}]
      }
      // }
      console.log(this.priceForm)
    },
    // 价格编辑
    editPrice(item) {
      console.log(item)
      this.priceForm.partsId = item.id
      this.getPartsPrice(item.id)
      this.$refs.priceForm.resetFields()
      this.priceForm.priceListOne = [{}]
      this.priceForm.priceListZero = [{ orderQuantity: 1, price: '' }]
      this.priceEdit = true
      this.priceOkLoading = false
    },
    // 价格类型变化
    changeRadio() {
      // for (let item of this.$refs.priceForm.fields) {
      //   if (item.prop === 'price') {
      //     item.resetField()
      //     break
      //   }
      // }
      // console.log(this.priceForm.priceType)
      // this.priceForm.priceList = [{}]
      // if (this.priceForm.priceType == 0) {
      //   this.priceForm.priceList = [{ orderQuantity: 1, price: '' }]
      // }
    },
    // 销价价格变化事件
    priceEvent(index) {
      console.log(this.priceForm.priceListOne.length, index)
      if (
        index == this.priceForm.priceListOne.length - 1 &&
        this.priceForm.priceListOne.length < 5
      ) {
        console.log(111111)
        this.priceForm.priceListOne.push({})
      }
    },
    // 价格删除事件
    priceDel(index) {
      console.log(index)
      this.priceForm.priceListOne.splice(index, 1)
    },
    priceOk() {
      console.log(this.priceForm.priceListOne)
      this.$refs.priceForm.validate(async valid => {
        console.log(valid)
        if (valid) {
          this.priceOkLoading = true
          let data = {
            partsId: this.priceForm.partsId,
            priceType: this.priceForm.priceType - 0
            // priceVOS: this.priceForm.priceList
          }
          if (data.priceType == 1) {
            data.priceVOS = this.priceForm.priceListOne
          } else {
            data.priceVOS = this.priceForm.priceListZero
          }
          console.log(data)
          let res = await savePartsPrice(data)
          console.log(res)
          this.priceOkLoading = false
          if (res.status) {
            this.priceEdit = false
            this.getList()
          }
        }
      })
    },
    priceCancel() {
      this.priceEdit = false
    },
    // 库存编辑
    editStock(item) {
      this.$refs.stockForm.resetFields()
      this.stockOkLoading = false
      console.log(item)
      this.stockForm = {
        partId: item.id,
        name: item.fullName,
        stock: item.stock
      }
      this.stockEdit = true
    },
    stockOk() {
      this.$refs.stockForm.validate(async valid => {
        console.log(valid)
        if (valid) {
          this.stockOkLoading = true
          let data = {
            partId: this.stockForm.partId,
            stock: this.stockForm.stock
          }
          let res = await setStock(data)
          console.log(res)
          this.stockOkLoading = false

          this.stockEdit = false
          this.getList()
        }
      })
    },
    stockCancel() {
      this.stockEdit = false
    }
  }
}
